import React from "react"

// components
import { Space, Typography, Avatar } from "antd"

// i18n
import { useTranslation } from "react-i18next"

// utils
import { formatAsCurrency } from "utils/currency"

const MenuItem = ({ item }) => {
  const { i18n } = useTranslation()
  const lang = i18n.resolvedLanguage

  const name = item.name_i18n?.[lang] ?? item.name
  const info = item.info_i18n?.[lang] ?? item.info

  return (
    <Space direction="vertical">
      <Space>
        <Typography.Text
          style={{
            // width: 36,
            display: "inline-block",
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
          }}
        >
          {item.id}
        </Typography.Text>
        <Typography.Text
          style={{
            width: 2,
            display: "inline-block",
          }}
        >
          |
        </Typography.Text>
        <Typography.Text strong italic>
          {name}
          {/* {item.name.length > 17 ? `${item.name.slice(0, 17)}...` : item.name} */}
        </Typography.Text>
        {item.scharf === 2 ? (
          <span
            style={{
              wordBreak: "keep-all",
              whiteSpace: "nowrap",
            }}
          >
            <Avatar
              src="/icons/chili.png"
              size={16}
              alt="icon-chili"
              style={{ marginRight: "-10px" }}
            />
            <Avatar src="/icons/chili.png" size={16} alt="icon-chili" />
          </span>
        ) : item.scharf === 1 ? (
          <Avatar src="/icons/chili.png" size={16} alt="icon-chili" />
        ) : null}
        {item.vegetarisch ? (
          <Avatar src="/icons/leaf.png" size={16} alt="icon-leaf" />
        ) : null}
        <Typography.Text
          style={{
            width: 4,
            display: "inline-block",
          }}
        >
          -
        </Typography.Text>
        <Typography.Text
          style={{
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
          }}
        >
          {formatAsCurrency(item.preis)}
        </Typography.Text>
      </Space>

      <Typography.Paragraph italic className="mobile-extra">
        {info}
      </Typography.Paragraph>
    </Space>
  )
}

export default MenuItem
